import React, { useEffect } from 'react'
import getPlacePermissions from '../services/getPlacePermissions'

export const USER_STATUS = {
  SUPER_ADMIN: 'super',
  NOT_AUTHORIZED: 'not-authorized',
  LOADING: 'loading',
  ERROR: 'error',
}

export default function useUserAdminRoleStatus() {
  const [userStatus, setUserStatus] = React.useState('loading')

  useEffect(() => {
    getPlacePermissions()
      .then((permissions) => {
        if (permissions?.PERM_PLACES_ADMIN_APP) {
          setUserStatus(USER_STATUS.SUPER_ADMIN)
        } else {
          setUserStatus(USER_STATUS.NOT_AUTHORIZED)
        }
      })
      .catch(() => {
        setUserStatus(USER_STATUS.ERROR)
      })
  }, [])

  return userStatus
}
